(function () {
    "use strict";

    angular.module("cardspotWeb.areas.enterSales")
    .controller("BannerAcceptance", BannerAcceptance);

    BannerAcceptance.$inject = ["$scope", "$uibModalInstance", "appConfig", "authService"];

    function BannerAcceptance($scope, $uibModalInstance, appConfig, authService) {
        var model = this;
        model.confirmAcceptance = confirmAcceptance;

        function confirmAcceptance(confirmed) {
            if (confirmed) {
                let contactId = authService.currentContactId();
                appConfig.saveBannerNotificationAcceptance(contactId, confirmed)
                    .then(resp => {
                        if (resp?.data?.succeeded) {
                            $uibModalInstance.close();
                        }
                    })
            } else {
                $uibModalInstance.dismiss("cancel");
            }
        }
    }
}());
